import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import { fetchAll } from "../../ApiBaseUrl";
import { useLoading } from "../../context/loading";

const BranchMaster = () => {
  const navigate = useNavigate();

  const { user, AccessData } = useContext(UserDetailsContext);
  const id = user?.id;

  const { circleLoading, setCirleLoading } = useLoading();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [branchList, setBranchList] = useState([]);

  const branchTable = {
    columns: [
      {
        field: "branchName",
        headerName: "Branch Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "address",
        headerName: "Address",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "state",
        headerName: "State",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "zipCode",
        headerName: "Zip Code",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "branchIncharge",
        headerName: "Branch Incharge",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: branchList.map((data, i) => ({
      id: data.id,
      branchName: data.name,
      description: data.description,
      address: data.address,
      state: data.state,
      zipCode: data.zipCode,
      branchIncharge: data.branchIncharge,
    })),
  };

  const handleNewBranch = () => {
    navigate("/branch/add-branch");
  };

  const onEmployeeListClick = (e) => {
    if (e?.id) {
      navigate(`/branch/add-branch`, { state: e?.id });
    }
  };

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        setBranchList(data?.allBranch);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Branch List
                </MaterialTypography>
              </Stack>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewBranch()}
              >
                Add Branch
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={branchTable?.rows}
          columns={branchTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          loading={pageState.loading}
          onRowClick={onEmployeeListClick}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Branch Creations data found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Branch details. Click on the "Add
                  Branch" button to start adding Branch details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default BranchMaster;
